import {
  categories,
  categoriesWithAnswers,
  type Category,
} from '../data/categories';
import {
  intersectionExists,
  seededShuffle,
  // date,
  appendCustomCategories,
  getSaturdayGame,
} from './utils';

const ITERATIONS = 2000;

type CustomGames = Record<string, Category[]>;

const customGames: CustomGames = {};

export function generateBoard(customDate: Date) {
  let gameId = 0;
  const customGame = customGames[customDate.toDateString()];

  // Top loop just provides a modifier for the seedShuffle in case the main loop fails to find a game
  for (let i = 0; i < ITERATIONS; i++) {
    let valid = true;

    const [shuffledCategories, seed] = seededShuffle<Category>(
      [...categories],
      i,
      customDate
    );

    if (customDate.getDay() === 6) {
      const { rows: satRows, cols: satCols } = getSaturdayGame(customDate);

      return {
        rows: satRows,
        cols: satCols,
        gameId: seed,
        iterationsRequired: ITERATIONS,
      };
    }

    // Main loop cycles through the shuffled array to find a valid game
    for (let j = 0; j <= categories.length - 6; j++) {
      let rows = shuffledCategories.slice(j, j + 3);
      let cols = shuffledCategories.slice(j + 3, j + 6);

      if (customGame) {
        const [newRows, newCols] = appendCustomCategories(
          rows,
          cols,
          customGame
        );

        rows = newRows;
        cols = newCols;
      }

      // Check if valid
      for (let row of rows) {
        for (let column of cols) {
          if (!intersectionExists(row, column, categoriesWithAnswers, 2)) {
            valid = false;
            break;
          }
        }
        if (!valid) {
          gameId = seed;
          break;
        }
      }

      if (valid) return { rows, cols, gameId, iterationsRequired: i };
    }
  }

  return { rows: [], cols: [], gameId, iterationsRequired: ITERATIONS };
}
